/* 注册全局组件 */
import Header from "./inc/Header";
import sidebar from "./inc/sidebar";
import Footer from "./inc/footer";
import Top from "./inc/top";
// account里的组件
import logohead from "./account/logohead";
import loginelse from "./account/loginelse";
// 作家中心
import authorHeader from "./author/authorHeader";
import writelist from "./author/writelist";
import pop from "./author/pop";
import chapterList from "./author/chapterList";
import authorWrite from "./author/authorWrite";
import triggernav from "./author/triggernav";
/* 没信息等空页面 */
import noneHint from "./author/noneList";
// 确认弹窗
import surePop from "./inc/surepop.vue";
/* ======用户 */
// 书籍介绍卡片
import bookIntro from "./book/bookIntro";
// 书籍推荐
import bookRecommend from "./book/bookRecommend";
// 一行6个
import sixRecommend from "./book/sixRecommend";
import simpleRecommend from "./book/simpleRecommend";
// 一行3个
import threeRecommend from "./book/threeRecommend";
// small-six
import smallSixRecommend from "./book/smallSixRecommend";
import authorbar from "./author/authorbar";
const comments = {
  install: function(Vue) {
    Vue.component("Header", Header);
    Vue.component("Footer", Footer);
    Vue.component("Top", Top);
    Vue.component("logohead", logohead);
    Vue.component("loginelse", loginelse);
    Vue.component("sidebar", sidebar);
    Vue.component("authorbar", authorbar);
    Vue.component("writeList", writelist);
    Vue.component("authorHeader", authorHeader);
    Vue.component("pop", pop);
    Vue.component("authorWrite", authorWrite);
    Vue.component("chapterList", chapterList);
    Vue.component("triggernav", triggernav);
    Vue.component("noneHint", noneHint);
    Vue.component("surePop", surePop);
    Vue.component("bookIntro", bookIntro);
    Vue.component("bookRecommend", bookRecommend);
    Vue.component("sixRecommend", sixRecommend);
    Vue.component("simpleRecommend", simpleRecommend);
    Vue.component("threeRecommend", threeRecommend);
    Vue.component("smallSixRecommend", smallSixRecommend);
  }
};
export default comments;
